import React,{forwardRef, useState, useEffect} from 'react'
import ServiceAttributeAssociationForm from './ServiceAttributeAssociationForm'
import UpdateDrawerInfo from '../../../../../../../../../component/common/UpdateDrawerInfo';
const ServiceAttributeAssociationUpdateDrawer = forwardRef((props, ref) => {
    const {
        formData,
        saveServiceAttributeAssociate,
        serviceAttributeAssUpdateData,
        isButtonLoader,
        drawerIsOpen
    } = props;

    const [updateInfo, setUpdateInfo] = useState({
        isOpen: '',
        title: '',
        information: ''
    });

    const colmd = updateInfo.isOpen === 'open' ? 'col-md-7' : 'col-md-12'
     useEffect(() => {
        props.isUpdateInfo(updateInfo)
    }, [updateInfo]);
    
    useEffect(() => {
        if(!drawerIsOpen){
            setUpdateInfo({
                isOpen: 'close',
                title: '',
                information: '',
            })
        }
    },[drawerIsOpen])


    return (
        <>
            <div className='row p-5'>
                <div className={`${colmd}`}>
                    <ServiceAttributeAssociationForm
                        formData={formData}
                        saveServiceAttributeAssociate={saveServiceAttributeAssociate}
                        serviceAttributeAssUpdateData={serviceAttributeAssUpdateData}
                        formActionType={'update'}
                        ref={ref}
                        isButtonLoader={isButtonLoader}
                        isInfoOpenHandler={(data) => 
                            setUpdateInfo({
                                isOpen: data.type,
                                title: data.data.title,
                                information: data.data.info,
                            })
                        }
                    />
                </div>
                {
                    updateInfo.isOpen === 'open' &&
                    <div className={`col-md-5`}>
                        <UpdateDrawerInfo
                            title={updateInfo.title}
                            information={updateInfo.information}
                            infoCloseOnClick={() => 
                                setUpdateInfo({
                                    isOpen: '',
                                    title: '',
                                    information: '',
                                })
                            }
                        />
                    </div>
                }
            </div>
        </>
    )
})

export default ServiceAttributeAssociationUpdateDrawer